import "react-responsive-carousel/lib/styles/carousel.min.css";
import React, {useState} from "react";
import {useAppDispatch} from "../../../app/hooks";
import {focusVehicle} from "../../chatbotSlice";
import { VehicleDetails } from "../../vehicleDetailsSlice";

export enum SliderButtonPosition {
    BUTTON_LEFT = "BUTTON_LEFT",
    BUTTON_RIGHT = "BUTTON_RIGHT"
}

interface VehicleSliderButtonProps {
    currentVehicleIndex: number,
    setCurrentVehicleIndex: (cur: number) => void,
    vehicles: VehicleDetails[],
    position: SliderButtonPosition
}

export const VehicleSliderButton: React.FC<VehicleSliderButtonProps> = ({
                                                                             currentVehicleIndex,
                                                                             setCurrentVehicleIndex,
                                                                             vehicles,
                                                                             position
                                                                         }) => {

    const dispatch = useAppDispatch();
    const [animate, setAnimate] = useState(false);
    const isLeft = position === SliderButtonPosition.BUTTON_LEFT;
    const isDisabled = isLeft
        ? currentVehicleIndex === 0
        : currentVehicleIndex === vehicles.length - 1;

    const setFocusVehicle = (value: string) => {
        dispatch(focusVehicle({VIN: value}));
    };

    const leftButtonOnClickHandle = (currentVehicleIndex: number, setCurrentVehicleIndex: (cur: number) => void, vehicles: VehicleDetails[]) => {
        if (currentVehicleIndex !== 0) {
            if (!!vehicles.length) {
                setFocusVehicle(vehicles[currentVehicleIndex - 1].vin);
            }
            setCurrentVehicleIndex(currentVehicleIndex - 1);
        }
    }
    const rightButtonOnClickHandle = (currentVehicleIndex: number, setCurrentVehicleIndex: (cur: number) => void, vehicles: VehicleDetails[]) => {
        if (currentVehicleIndex !== vehicles.length - 1) {
            if (!!vehicles.length) {
                setFocusVehicle(vehicles[currentVehicleIndex + 1].vin);
            }
            setCurrentVehicleIndex(currentVehicleIndex + 1);
        }
    }

    return <div
        key={position}
        onClick={() => {
            setAnimate(true);
            isLeft ? leftButtonOnClickHandle(currentVehicleIndex, setCurrentVehicleIndex, vehicles) :
                rightButtonOnClickHandle(currentVehicleIndex, setCurrentVehicleIndex, vehicles);
        }}
        className={`flex w-[48px] h-[48px] justify-center items-center !absolute bottom-[7px] z-50 
        ${isLeft ? "left-0" : "right-0 rotate-180"} -translate-y-2/4 bg-white shadow-md hover:shadow-lg rounded-lg 
        hover:cursor-pointer transition-transform 
        ${animate && "animate-blink"}
        ${isDisabled ? 'pointer-events-none animate-fade-out' : 'cursor-pointer hover:shadow-lg'}`}
        onAnimationEnd={() => {
            if (animate) {
                setAnimate(false);
            }
        }}
    >
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.5 15.8332L6.66667 9.99984L12.5 4.1665"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </div>
}
